import { render, staticRenderFns } from "./u-sitemap-outlined.vue?vue&type=template&id=5f5f136a&scoped=true"
import script from "./u-sitemap-outlined.vue?vue&type=script&lang=js"
export * from "./u-sitemap-outlined.vue?vue&type=script&lang=js"
import style0 from "./u-sitemap-outlined.vue?vue&type=style&index=0&id=5f5f136a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f136a",
  null
  
)

export default component.exports